import AnagraficaRegionaleTestPage from "./pages/AnagraficaRegionaleTestPage.vue";

export default {
    AnagraficaRegionaleTestPage,
}